import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBanner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 48.956 36.717",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Banner",
		d: "M8693.077,22820.715a4.089,4.089,0,0,1-4.077-4.076v-28.557a4.1,4.1,0,0,1,4.077-4.084h40.8a4.1,4.1,0,0,1,4.083,4.084v28.557a4.09,4.09,0,0,1-4.083,4.076Zm-2.039-32.633v28.557a1.931,1.931,0,0,0,2.039,2.039h40.8a1.927,1.927,0,0,0,2.038-2.039v-28.557a1.928,1.928,0,0,0-2.038-2.045h-40.8A1.931,1.931,0,0,0,8691.038,22788.082Zm4.016,28.086a1.722,1.722,0,0,1-1.679-1.678v-23.916a1.712,1.712,0,0,1,1.679-1.674h16.752a1.712,1.712,0,0,1,1.672,1.674v23.916a1.723,1.723,0,0,1-1.672,1.678Zm1.563-4.381h13.647l-4.1-5.475-3.688,4.775-2.594-3.545Zm20.921-2.291v-2.039h14.278v2.039Zm0-6.117v-2.039h14.278v2.039Zm0-6.121v-2.039h14.278v2.039Z",
		transform: "translate(-8689 -22783.998)"
	})
});
export default SvgBanner;
